"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefineObjectiveSubspace = void 0;
/* eslint-disable react/no-children-prop */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var PredictiveModel_1 = require("../content/PredictiveModel");
var Info_14px_small_1 = require("../img/Info_14px_small");
var TestIds_1 = require("../util/TestIds");
var Utils_1 = require("../util/Utils");
var DefineObjectiveSubspace = /** @class */ (function (_super) {
    __extends(DefineObjectiveSubspace, _super);
    function DefineObjectiveSubspace(props) {
        var _this = _super.call(this, props) || this;
        _this.getFieldDropdownListItems = function (fields) {
            var array = [];
            for (var i = 0; i < fields.length; i++) {
                array.push({ value: _this.concatString(fields[i].name, fields[i].type, ' - ') });
            }
            return array;
        };
        _this.getGoalDropdownListItems = function () {
            var array = [];
            array.push({ value: Utils_1.Goal.Maximize });
            array.push({ value: Utils_1.Goal.Minimize });
            return array;
        };
        _this.goalListProps = {
            items: _this.getGoalDropdownListItems(),
        };
        _this.goalProps = {
            testId: TestIds_1.GOAL_DROPDOWN_OPTIONS_TEST_ID,
            list: React.createElement(widgets_1.List, __assign({}, _this.goalListProps)),
            type: widgets_1.DropdownButtonType.Outline,
            label: Localize_1.Messages.goalListTitle(),
        };
        _this.getAlgorithmDropdownListItems = function () {
            var array = [];
            array.push({ value: Utils_1.Algorithm.GBM });
            array.push({ value: Utils_1.Algorithm.GLM });
            array.push({ value: Utils_1.Algorithm.Model_Tournament });
            array.push({ value: Utils_1.Algorithm.RandomForest });
            array.push({ value: Utils_1.Algorithm.XGBoost });
            return array;
        };
        _this.algorithmListProps = {
            items: _this.getAlgorithmDropdownListItems(),
        };
        _this.algorithmProps = {
            testId: TestIds_1.ALGORITHM_DROPDOWN_OPTIONS_TEST_ID,
            list: React.createElement(widgets_1.List, __assign({}, _this.algorithmListProps)),
            type: widgets_1.DropdownButtonType.Outline,
            label: Localize_1.Messages.modelAlgorithmTitle(),
        };
        _this.getField = function (fields, fieldToSearch) {
            return fields.find(function (field) { return field.name === fieldToSearch; });
        };
        _this.getUpdatedOutcome = function (value) {
            var fields;
            var success = '';
            var failure = '';
            var outcome;
            var datasource = PredictiveModel_1.DataSourceIdToDataSource.get(_this.props.objective.dataSourceId);
            if (datasource) {
                fields = datasource.fields;
                var field = _this.getField(fields, value.split('-')[0].trim());
                if (field.type === 'Text') {
                    success = field.domain[0];
                    failure = field.domain[1];
                }
                outcome = {
                    outcomeField: value.split('-')[0].trim(),
                    outcomeType: value.split('-')[1].trim(),
                    successValue: success,
                    failureValue: failure,
                };
            }
            return outcome;
        };
        _this.handleChangeCallback = function (value, type) {
            switch (type) {
                case 'outcomeField':
                    _this.props.setObjective(__assign(__assign({}, _this.props.objective), _this.getUpdatedOutcome(value)));
                    _this.props.setModelStatus(Utils_1.ModelStatus.ObjectiveDefined);
                    break;
                case 'goal':
                    _this.props.setObjective(__assign(__assign({}, _this.props.objective), { goal: value }));
                    break;
                case 'algorithm':
                    _this.props.setObjective(__assign(__assign({}, _this.props.objective), { algorithm: value }));
                    break;
            }
        };
        _this.getSFDatasourceDropdownListItems = function () {
            var array = [];
            PredictiveModel_1.DataSourceIdToDataSource.forEach(function (value, key) {
                array.push({ value: key });
            });
            return array;
        };
        _this.handleDataSourceChangeCallback = function (value) {
            var datasource = PredictiveModel_1.DataSourceIdToDataSource.get(value);
            _this.props.setObjective(__assign(__assign({}, _this.props.objective), { dataSourceVersionId: datasource.version, dataSourceId: value }));
            var fields = datasource.fields;
            _this.setState({ outcomeFieldList: _this.getFieldDropdownListItems(fields) });
        };
        _this.concatString = function (str1, str2, delimit) {
            return "" + str1 + delimit + str2;
        };
        _this.getFieldTooltipContent = function () { return React.createElement("span", null, Localize_1.Messages.fieldTooltip()); };
        _this.getGoalTooltipContent = function () { return React.createElement("span", null, Localize_1.Messages.goalTooltip()); };
        _this.getAlgorithmTooltipContent = function () { return React.createElement("span", null, Localize_1.Messages.algorithmTooltip()); };
        _this.state = {
            outcomeFieldList: [],
        };
        _this.props.setObjective({
            dataSourceId: 'Select',
            dataSourceVersionId: 'Select',
            outcomeField: 'Select',
            goal: Utils_1.Goal.Maximize,
            algorithm: Utils_1.Algorithm.GLM,
            outcomeType: '',
            successValue: '',
            failureValue: '',
        });
        return _this;
    }
    DefineObjectiveSubspace.prototype.render = function () {
        var _this = this;
        var outcomeField = this.props.objective.outcomeField;
        var outcomeType = this.props.objective.outcomeType;
        var dataSourceId = this.props.objective.dataSourceId;
        if (outcomeType) {
            outcomeField = this.concatString(outcomeField, outcomeType, ' - ');
        }
        var goal = this.props.objective.goal;
        var algorithm = this.props.objective.algorithm;
        return (React.createElement("div", { style: {
                width: '80%',
                height: '90%',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: '#ffffff',
            } },
            React.createElement("div", { style: {
                    width: '30%',
                    height: '90%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#ffffff',
                } },
                React.createElement("div", { style: { marginTop: '30px', marginBottom: '10px', width: '100%', textAlign: 'left', wordBreak: 'break-word' } },
                    React.createElement("div", { style: { width: '90%', alignItems: 'left', display: 'flex' } },
                        React.createElement("div", { style: { width: '100%', marginTop: '10px' } },
                            React.createElement(widgets_1.SingleSelectDropdown, { testId: TestIds_1.DATASOURCEID_DROPDOWN_OPTIONS_TEST_ID, label: Localize_1.Messages.salesforceDatasourceIdListTitle(), list: React.createElement(widgets_1.List, { items: this.getSFDatasourceDropdownListItems(), selectedValue: dataSourceId }), onChange: function (field) {
                                    _this.handleDataSourceChangeCallback(field);
                                }, type: widgets_1.DropdownButtonType.Outline, disabled: false, value: dataSourceId })))),
                React.createElement("div", { style: { marginTop: '10px', marginBottom: '10px', width: '100%', textAlign: 'left', wordBreak: 'break-word' } },
                    React.createElement("label", null, Localize_1.Messages.chooseTargetTitle())),
                React.createElement("div", { style: { marginTop: '10px', marginBottom: '10px', width: '100%', textAlign: 'left', wordBreak: 'break-word' } },
                    React.createElement("label", null, Localize_1.Messages.chooseTargetDescription())),
                React.createElement("div", { style: { width: '90%', alignItems: 'left', display: 'flex' } },
                    React.createElement("div", { style: { width: '100%', marginTop: '10px' } },
                        React.createElement(widgets_1.SingleSelectDropdown, { testId: TestIds_1.FIELD_DROPDONW_LIST_TEST_ID, label: Localize_1.Messages.outcomeFieldListTitle(), list: React.createElement(widgets_1.List, { items: this.state.outcomeFieldList, selectedValue: outcomeField }), onChange: function (field) {
                                _this.handleChangeCallback(field, 'outcomeField');
                            }, type: widgets_1.DropdownButtonType.Outline, disabled: false, value: outcomeField })),
                    React.createElement("div", { style: { marginTop: '10px' } },
                        React.createElement(widgets_1.Tooltip, { getContent: this.getFieldTooltipContent },
                            React.createElement("span", null, React.createElement(Info_14px_small_1.InfoSmall, null))),
                        ' ')),
                React.createElement("div", { style: { width: '90%', alignItems: 'left', display: 'flex' } },
                    React.createElement("div", { style: { width: '100%', marginTop: '10px' } },
                        React.createElement(widgets_1.SingleSelectDropdown, { testId: TestIds_1.GOAL_DROPDOWN_LIST_TEST_ID, label: Localize_1.Messages.goalListTitle(), list: React.createElement(widgets_1.List, { items: this.getGoalDropdownListItems(), selectedValue: goal }), onChange: function (field) {
                                _this.handleChangeCallback(field, 'goal');
                            }, type: widgets_1.DropdownButtonType.Outline, disabled: false, value: goal })),
                    React.createElement("div", { style: { marginTop: '10px' } },
                        React.createElement(widgets_1.Tooltip, { getContent: this.getGoalTooltipContent },
                            React.createElement("span", null, React.createElement(Info_14px_small_1.InfoSmall, null))))),
                React.createElement("div", { style: { width: '90%', alignItems: 'left', display: 'flex' } },
                    React.createElement("div", { style: { width: '100%', marginTop: '10px' } },
                        React.createElement(widgets_1.SingleSelectDropdown, { testId: TestIds_1.ALGORITHM_DROPDOWN_LIST_TEST_ID, label: Localize_1.Messages.modelAlgorithmTitle(), list: React.createElement(widgets_1.List, { items: this.getAlgorithmDropdownListItems(), selectedValue: algorithm }), onChange: function (field) {
                                _this.handleChangeCallback(field, 'algorithm');
                            }, type: widgets_1.DropdownButtonType.Outline, disabled: false, value: algorithm })),
                    React.createElement("div", { style: { marginTop: '10px' } },
                        React.createElement(widgets_1.Tooltip, { getContent: this.getAlgorithmTooltipContent },
                            React.createElement("span", null, React.createElement(Info_14px_small_1.InfoSmall, null))),
                        ' ')),
                React.createElement("div", { style: {
                        width: '100%',
                        borderTopWidth: 2,
                        borderTopStyle: 'solid',
                        borderTopColor: '#605C5C',
                        height: 0,
                        marginTop: '50px',
                    } }),
                React.createElement("div", { style: { marginTop: '10px', marginBottom: '10px', width: '100%', textAlign: 'left', wordBreak: 'break-word' } },
                    React.createElement("label", null, Localize_1.Messages.forNextStepDescription())),
                React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
                    React.createElement(widgets_1.ButtonWidget, { testId: TestIds_1.CHOOSE_TARGET_NEXT_STEP_BUTTON_TEST_ID, buttonType: widgets_1.ButtonType.Primary, disabled: this.props.objective.outcomeField === 'Select', onClick: function () { return _this.props.setSubspace(Utils_1.SubspaceType.Train); } }, Localize_1.Messages.nextStepButton())))));
    };
    return DefineObjectiveSubspace;
}(React.PureComponent));
exports.DefineObjectiveSubspace = DefineObjectiveSubspace;
//# sourceMappingURL=DefineObjectiveSubspace.js.map